import { Box, Typography } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import { useOrdersQuery } from '@/services/orders'
import { columns, ORDER_FILTER_ONLY_COLUMNS } from './columns'
import DataGridTable, { type FilterValueOptions } from '@/components/shared/DataGridTable'
import { MED_REQUEST_STATUSES, ORDER_STATUSES } from '@/constants/statuses'

/**
 * The Status column shows a label; the filter has to send the `wc-*` value behind it. `Created` is
 * dropped from the item stages because every item passes through it.
 */
const FILTER_VALUE_OPTIONS: FilterValueOptions = {
  status: ORDER_STATUSES,
  orderItemStatus: MED_REQUEST_STATUSES.filter(status => status.value !== 'wc-item-created')
}

export default function OrdersPage() {
  const navigate = useNavigate()
  const { orders, count, isLoading, isFetching, dataGridConfig } = useOrdersQuery({ tableId: 'orders' })

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
      <Typography variant='pageTitle' component='h1' sx={{ fontSize: '24px' }}>
        Orders
      </Typography>

      <DataGridTable
        {...dataGridConfig}
        rows={orders}
        columns={columns}
        rowCount={count}
        loading={isLoading || isFetching}
        filterOnlyColumns={ORDER_FILTER_ONLY_COLUMNS}
        filterValueOptions={FILTER_VALUE_OPTIONS}
        showQuickFilter={false}
        onRowClick={params =>
          navigate(`/orders/${params.id}`, {
            state: { backLabel: 'Back to Orders', fallbackPath: '/orders' }
          })
        }
      />
    </Box>
  )
}
